import { CartesianChart } from '@/common/dashboard/charts/CartesianChart';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useEffect, useState } from 'react';

export const UsAmpChart = ({ formValues, brandIdToBrandName, custIdToCustName, distChannelIdToDistChannel, ctrtTypeIdToCtrtType }) => {

    const { subPeriodId, invPeriodId, brandIds, custIds, distChannelIds, ctrtTypeIds } = formValues;

    const rsrc = useRsrc();

    const [data, setData] = useState();

    const tooltipFormatter = ({ category, points }) => {
        if (!points?.length) {
            return '';
        }

        const total = points.reduce((sum, point) => sum + Number(point.y ?? 0), 0);
        const pointLines = points
            .map(point => ` <span style="color:${point.color}">●</span> ${point.seriesName}: <b>${Number(point.y ?? 0).toLocaleString('en-US')}</b><br/>`)
            .join('');

        return `
            <div>
                <b>${category ?? ''}</b><br/>
                ${pointLines}
                <span style="color:#666">●</span> Total: <b>${total.toLocaleString('en-US')}</b>
            </div>
        `;
    };

    useEffect(() => {
        if (!subPeriodId) {
            return;
        }

        const reqParam = {
            subPeriodId,
            invPeriodId,
            brandNames: brandIds.map(brandId => brandIdToBrandName[brandId]),
            custNames: custIds.map(custId => custIdToCustName[custId]),
            distChannels: distChannelIds.map(distChannelId => distChannelIdToDistChannel[distChannelId]),
            ctrtTypes: ctrtTypeIds.map(ctrtTypeId => ctrtTypeIdToCtrtType[ctrtTypeId])
        };

        rsrc.data('sc', 'US_AMP_CHART_DATA_PLUGIN', reqParam).then(res => {
            setData(res);
        });
    }, [subPeriodId, invPeriodId, brandIds, custIds, distChannelIds, ctrtTypeIds]);

    return (
        <>
            <CartesianChart 
                data={data}
                yLabel="Total Rebate Amount"
                xLabel="Payment Dimension"
                stacked={true}
                allowNegative={true}
                tooltipFormatter={tooltipFormatter}
            />
        </>
    );
}